(function(){
	var runFlag = true;
	if("tlabRecItemId" in window){
		myTlabRecItemId = formatItemId(tlabRecItemId);
	}else{
		runFlag = false;
	}

	var recommendWidth = 1;
	var recommendHeight = 1;
	var recommendDivIdName = 'tlab_beacon_view_get';

	if(runFlag){
		var recommendDivAttribute =
			'style="' + 
			'width:' + recommendWidth + 'px;' +
			'height:' + recommendHeight + 'px"';

		document.write(
			'<div id="' + recommendDivIdName + '" ' +
			recommendDivAttribute + '></div>'
		);

		var Beacon_obj = new TLAB.Beacon(recommendDivIdName, myTlabRecItemId);
		Beacon_obj.width = recommendWidth;
		Beacon_obj.height = recommendHeight;
		Beacon_obj.sendRequest();
		delete Beacon_obj;
	}

	function formatItemId(argId){
		return argId;
	}
})();
